import { useTranslation } from 'react-i18next'

import { FLOATING_ELEMENT_PLACEMENT } from '../../../../../constants/common'
import { useContentOverflow } from '../../../../../hooks'
import { Avatar, AVATAR_HEIGHT_24 } from '../../../../Avatar'
import { EntityProfileHeaderInfoItemBase } from '../../../../Entity'
import { FloatingTooltip } from '../../../../Floating'
import Text from '../../../../Text'
import { getRentalPortalApplicantPortalAvatarProps } from '../../../RentalPortalApplicantPortalCell'
import {
  APPLICANT_PROFILE_INFO_ITEM_TITLE_KEY,
  QA_NAME_APPLICANT_PROFILE_INFO_PORTAL,
} from '../RentalPortalApplicantProfileHeaderInfoItems.constants'
import { getApplicantPortalReceivedValue } from '../RentalPortalApplicantProfileHeaderInfoItems.utils'

import * as styles from './ApplicantProfilePortalReceivedItem.module.css'

function ApplicantProfilePortalReceivedItem({
  applicant,
  className,
  contentWrapperClassName,
  titleClassName,
}) {
  const { t } = useTranslation()

  const { overflow: isValueOverflowing, setContentOverflowRef } =
    useContentOverflow()

  const value = getApplicantPortalReceivedValue({
    applicantData: applicant,
    t,
  })

  return (
    <EntityProfileHeaderInfoItemBase
      actions={null}
      canEdit={false}
      className={className}
      contentExist={Boolean(value)}
      contentWrapperClassName={contentWrapperClassName}
      title={APPLICANT_PROFILE_INFO_ITEM_TITLE_KEY.portalReceived}
      titleClassName={titleClassName}
    >
      <span className={styles.ApplicantProfilePortalReceivedItem}>
        {applicant?.source ? (
          <Avatar
            {...getRentalPortalApplicantPortalAvatarProps({ applicant, t })}
            className={styles.logo}
            size={AVATAR_HEIGHT_24}
          />
        ) : null}
        <FloatingTooltip
          content={value}
          disabled={!isValueOverflowing}
          placement={FLOATING_ELEMENT_PLACEMENT.top}
        >
          <Text
            disabled={!value}
            isSecondary={!value}
            qaName={QA_NAME_APPLICANT_PROFILE_INFO_PORTAL}
            ref={setContentOverflowRef}
          >
            {value || t('Select.NoDataKey')}
          </Text>
        </FloatingTooltip>
      </span>
    </EntityProfileHeaderInfoItemBase>
  )
}

export default ApplicantProfilePortalReceivedItem
